<template>
  <el-select class="td_select"
             v-model="values"
             default-first-option
             filterable
             placeholder="请输入关键词"
             :clearable="clearable"
             :disabled="disabled"
             :multiple="multiple"
             @clear="clearAction"
             :loading="loading">
    <el-option
      class="td_option"
      v-for="(item, index) in options"
      :key="index"
      :label="item.label"
      :value="Number(item.value)"
      @click.native="handleSelect(item)">
      <span style="float: left;"><i class="fa fa-modx" :style="{'color': '#66b1ff','margin-right': '5px'}"></i>{{ item.label }}</span>
    </el-option>
  </el-select>
</template>
<script>

import { getDictUrl } from '@/api/sys.ui'
import { validatenull } from '@/tdcommon/validate'
export default {
  name: 'd2-container-dept',
  data () {
    return {
      values: validatenull(this.value) ? null : Number(this.value),
      options: [],
      loading: false
    }
  },
  props: {
    value: {
      type: [Number, String],
      default: () => null
    },
    clearable: {
      type: Boolean,
      default: () => false
    },
    disabled: {
      type: Boolean,
      default: () => false
    },
    multiple: {
      type: Boolean,
      default: () => false
    },
    url: {
      type: String,
      default: () => ''
    }
  },
  methods: {
    findData () {
      this.loading = true
      getDictUrl(this.url).then(response => {
        this.loading = false
        if (response.code === 0) {
          this.options = response.data
        }
      }).catch(() => {
        this.loading = false
      })
    },
    handleSelect (val) {
      console.log('handleSelect', val)
      this.$emit('change', val)
    },
    clearAction () {
      this.$emit('change', '')
    }
  },
  watch: {
    values: function (val, oldVal) {
      this.$emit('input', val)
    },
    value: function (val, oldVal) {
      if (!validatenull(val)) {
        this.values = Number(val)
      } else {
        this.values = null
      }
      // this.$emit('change', val)
    }
  },
  mounted () {
    this.findData()
  }
}
</script>

<style lang="scss" scoped>
</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/components/d2-container-dept/index.vue"
}
</vue-filename-injector>
